// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { calendarCheckLines16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-calendar-check-lines': IconCalendarCheckLines;
    }
}

/**
 * The icon component for the 'calendarCheckLines' icon
 */
export class IconCalendarCheckLines extends Icon {
    public constructor() {
        super(calendarCheckLines16X16);
    }
}

registerIcon('icon-calendar-check-lines', IconCalendarCheckLines);
export const iconCalendarCheckLinesTag = 'nimble-icon-calendar-check-lines';
